// Lightweight, dependency-free toast bus. Lifted from
// My.Tms.Old/utils/toast.ts — `showToast()` dispatches a CustomEvent and the
// `<ToastContainer />` mounted at the app shell listens for it.
//
// Why this shape (vs. a Context/provider)?
//   • zero prop-drilling — any module (hooks, mutations, plain functions) can
//     call `showToast()` without needing a hook handle.
//   • survives across React tree renders — listener is attached to `window`.
//   • trivial to mock in tests (just spy on dispatchEvent).

export type ToastType = 'info' | 'success' | 'warning' | 'error';

export interface ToastPayload {
  message: string;
  /** Defaults to `info`. */
  type?: ToastType;
  /** Auto-dismiss timeout in ms. Defaults to 3000. Pass `0` to make it sticky. */
  durationMs?: number;
}

/** Internal event name — kept stable so the container picks every dispatch up. */
export const TOAST_EVENT = 'my-ui:toast';

export function showToast(payload: ToastPayload): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<ToastPayload>(TOAST_EVENT, { detail: payload }));
}
